import { Injectable } from '@angular/core';
import { ClientLocalization, ClientLocalizationRequest } from '@ats/api/cm';
import { gql, Query } from 'apollo-angular';

@Injectable({
	providedIn: 'root',
})
export class ClientLocalizationGql extends Query<
	{ clientLocalizationList: ClientLocalization[] },
	{ request: ClientLocalizationRequest }
> {
	document = gql`
		query clientLocalizationList($request: ClientLocalizationRequest!) {
			clientLocalizationList(request: $request) {
				name
				locType
				value
				cultureInfoName
				englishValueResolved
				__typename
			}
		}
	`;
}
